import { Component, HostListener, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { map, switchMap, tap } from "rxjs/operators";
import { DialogImage } from "src/app/data/dialog-image";
import { Currency } from "src/app/data/metal-list";
import { PaymentType } from "src/app/model/checkout/payment-type";
import { DialogService } from "src/service/dialog.service";
import { UserService } from "src/service/user.service";
import { WalletService } from "../../wallet/wallet.service";
import { CheckoutService } from "../checkout.service";
import {combineLatest} from 'rxjs';
// import {IPayPalConfig} from 'ngx-paypal';

@Component({
  selector: "app-select-payment",
  templateUrl: "./select-payment.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class SelectPaymentComponent implements OnInit {

  constructor(
    public checkoutService: CheckoutService,
    private dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private walletService: WalletService,
    private userService: UserService
  ) {}

  loading = false;
  type;
  paymentForm: FormGroup;
  showVaultRedirectText;
  needPayEuroVault;

  ngOnInit(): void {
    this.paymentForm = new FormGroup({
      paymentType: new FormControl(),
    });

    this.type = this.checkoutService.selectedPaymentRequest.value;
    this.filteredPaymentTypes = this.paymentTypes;

    if (this.checkoutService.createSavingPlanTypes.includes(this.type.type)) {
      this.filteredPaymentTypes = this.paymentTypes.splice(1);
    }

    this.needPayEuroVault = this.checkoutService.selectedShipment == "VAULT";
    this.showVaultRedirectText = this.paymentForm
      .get("paymentType")
      .valueChanges.pipe(
        map((value) => value.type == "WALLET_EURO" && this.needPayEuroVault)
      );
  }



  @HostListener("window:popstate", ["$event"])
  onBrowserBackBtnClose(event: Event) {
    event.preventDefault();
    this.checkoutService.goingBack = true;
  }

  onSubmit() {

    if (this.checkoutService.totalPrice.value >= 2000) {
      if (this.userService.user.value.documentStatus != "APPROVED") {
        this.dialogService.showErrorDialog("DOCUMENTS_NEED_APPROVED");
        return;
      }
    }

    const paymentType = this.paymentForm.value.paymentType;

    if (paymentType == null) {
      return;
    }

    this.loading = true;
    const { routerLink, queryParams, request, afterSuccess, afterCloseDialog } =
      this.checkoutService.selectedPaymentRequest.value;
    this.checkoutService.refreshCheckout({ paymentType: paymentType?.type });
    if (paymentType.value == PaymentType.PAYPAL) {
      this.router.navigate(["../paypal"], {
        relativeTo: this.route,
      });
    } else if (paymentType.value == PaymentType.CREDIT_CARD || this.needPayEuroVault) {
      this.router.navigate(["../paypal"], {
        relativeTo: this.route,
        queryParams: { vaultPayProduct: this.needPayEuroVault },
      });
    } else  {
      if (
        this.checkoutService.totalPrice.value >
        this.walletService.getCurrencyEuroAmount(Currency.EURO)
      ) {
        this.dialogService
          .showErrorDialog(
            "INSUFFICIENT_BALANCE",
            DialogImage.INSUFFICIENT_BALANCE
          )
          .subscribe(() => {
            this.router.navigate([routerLink], {
              relativeTo: this.route,
              queryParams,
            });
          });
        return;
      }

      request()
        .pipe(
          tap(() => (this.loading = false)),
          switchMap(() => afterSuccess()),
          switchMap(() => afterCloseDialog()),
          switchMap(() => this.walletService.syncWalletBalance())
        )
        .subscribe(
          () => {
            this.router.navigate([routerLink], {
              relativeTo: this.route,
              queryParams,
            });
          },

          (error) => {
            this.loading = false;
            this.dialogService.showErrorDialog(error);
          }
        );
    }
  }

  filteredPaymentTypes;
  paymentTypes = [
    {
      title: "EURO_ACCOUNT",
      icon: "../../../../assets/icons/ic_pay_euro.svg",
      value: PaymentType.EURO_ACCOUNT,
      type: "WALLET_EURO",
    },
    // {
    //   title: "PAYPAL_CARD",
    //   icon: "../../../../assets/icons/ic_paypal.svg",
    //   value: PaymentType.PAYPAL,
    //   type: "CREDIT_CARD",
    // },
    {
      title: "CREDIT_CARD",
      icon: "../../../../assets/icons/ic_credit_card.svg",
      value: PaymentType.CREDIT_CARD,
      type: "CREDIT_CARD",
    },
    /*   {
      title: "PAYSAFE_CARD",
      icon: "../../../../assets/icons/ic_paysafe.svg",
      value: PaymentType.PAYSAFE,
      type: "WALLET_EURO",
    }, */
  ];

}
